import { render, staticRenderFns } from "./AllInventairePage.vue?vue&type=template&id=b34ddd4c&"
import script from "../../../public/js/img/Discoveryjs/InventoryAppJs/AllInventaires.js?vue&type=script&lang=js&"
export * from "../../../public/js/img/Discoveryjs/InventoryAppJs/AllInventaires.js?vue&type=script&lang=js&"
import style0 from "./AllInventairePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports